<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Pending To Shipment Orders</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            send_to_shipment: 'send_to_shipment',
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addSendToIntShipmentButton="true"
          :addSendAllToIntShipmentButton="true"
          :addQrCodeGenerateButton="true"
          :openSendToIntShipmentModal="openSendToIntShipmentModal"
          :sendAllToIntShipment="sendAllToIntShipment"
          :tableData="tableData"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :getByWarehouse="getByWarehouse"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
        ></preDatatableComponent>
        <!-- :intShipment="true" -->
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>

          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="qrCodeValues.find(x => x[0] == r.order_id) ? 'background-color: #FFF9C4' : '' "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[
                      r.order_id,
                      r.full_name,
                      r.phone_number,
                      r.user_id,
                      r.theOrderID,
                      r.is_ship_only,
                      r.product_name,
                    ]"
                    v-model="qrCodeValues"
                  />
                  <!-- r.deliver_branch_name,
                      r.deliver_branch_id_fk, -->
                </td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-users :orderData="r" />
                </td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <td><i
                    class="fa fa-qrcode"
                    aria-hidden="true"
                  ></i>{{ r.order_id }}</td>
                <td>{{ r.theOrderID }}</td>
                <td>{{ r.customer_id_fk }}</td>
                <td class="ws-nowrap">
                  <i v-if="r.fcm_token" class="material-icons customer-device-icon">smartphone</i> <i v-else class="material-icons customer-device-icon">language</i>                   <img v-if="r.profile_image" :src="`${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                    {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                  </span>
                  <span v-else>
                    {{ r.full_name }}
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                      (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                </td>
                <td>{{
                  r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : '')
                }}</td>
                <td>{{ r.quantity }}</td>
                <td>{{ r.country }}</td>
                <td>{{ r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : '' }}</td>
                <td>{{ r.purchase_note }}</td>
                <td>{{ r.note }}</td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <td>{{ r.bank_name }}</td>
                <td
                  v-if="$_has_perm('view_order_detail')"
                  style="padding-left:10px; padding-right:10px"
                >
                  <a
                    style="color:#01579B"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('send_to_shipment')"
                  style="padding-left:0px; padding-right:5px;"
                >
                    <a
                      style="color:#4FC3F7"
                      tooltip="Shipment this order"
                      @click="shipmentOrder(r.order_id)"
                    >
                      <i class="material-icons">directions_boat</i>
                    </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            :isPurchase="true"
            :isOrder="true"
            v-if="isMobile"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID]"
                    v-model="qrCodeValues"
                  />
                </td>
                <td>
                  <i
                    class="fa fa-qrcode"
                    aria-hidden="true"
                  ></i> {{ r.order_id }} , <br />
                  {{ r.theOrderID }} , <br />
                  {{
                    r.product_name.substr(0, 35) +
                      (r.product_name.length > 35 ? '...' : '')
                  }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                      (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                  <br />
                  {{ r.country }} ,
                  <br />
                  purchaseNote: {{ r.purchase_note }}
                  <br />
                  Quantity: {{ r.quantity }}
                </td>
                <td>
                  Customer name: {{ r.full_name }} , <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else>{{ r.created_at }}</span> <br />
                  Confirm date: {{ r.confirm_date }} , <br />
                  <a
                    v-if="$_has_perm('view_order_detail')"
                    style="color:#01579B; display: inline-block; padding-right: 3px"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                  <span
                    v-if="$_has_perm('return_shipment_order_to_purchased_order')"
                    style="padding-left:0px; padding-right:5px; float: left"
                  >
                    <a
                      style="color:#eb8545"
                      tooltip="Return to purchase"
                      @click="returnToPurchase(r.order_id)"
                    >
                      <i class="material-icons">settings_backup_restore</i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>


          <send-to-int-shipment
            :pendingShipment="true"
            :closeSendToIntShipmentModal="closeSendToIntShipmentModal"
            :sendToIntShipmentModal="sendToIntShipmentModal"
            :sendToIntShipmentData="sendToIntShipmentData"
            :sendToIntShipment="sendToIntShipment"
          >
          </send-to-int-shipment>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="sendWindow"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline"><i class="fa fa-plane"></i> Send to International Shipment</span>
        </v-card-title>
        <v-card-text>
          <p>Which plane do these orders go on? Orders sent together on one plane make one pallet.</p>
          <div
            v-for="g in sendGroups"
            :key="g.key"
            class="send-group"
          >
            <div class="send-group-title">
              <strong>{{ g.country || 'Origin not known' }}</strong>
              <span>{{ g.order_ids.length }} {{ g.order_ids.length == 1 ? 'order' : 'orders' }}</span>
            </div>
            <select
              class="form-control"
              v-model="g.pallet_id"
            >
              <option
                v-for="p in palletsFor(g)"
                :key="p.pallet_id"
                :value="p.pallet_id"
              >{{ p.tracking_number }}{{ p.flight_date ? ' · flight ' + p.flight_date : '' }}{{ g.warehouse_id ? '' : ' · ' + p.origin }}</option>
              <option value="new">New pallet (a new plane)</option>
              <option value="none">No pallet (send them without a pallet)</option>
              <option value="skip">Do not send these now</option>
            </select>
            <div
              v-if="g.pallet_id === 'new'"
              class="send-new"
            >
              <select
                v-if="!g.warehouse_id"
                class="form-control"
                v-model="g.new_warehouse_id"
              >
                <option :value="null">Origin of the plane</option>
                <option
                  v-for="w in warehouses"
                  :key="w.warehouse_id"
                  :value="w.warehouse_id"
                >{{ w.country }}</option>
              </select>
              <input
                type="text"
                class="form-control"
                placeholder="Plane / pallet tracking number"
                v-model="g.new_number"
              />
              <input
                type="date"
                class="form-control"
                title="Flight date"
                v-model="g.new_date"
              />
            </div>
            <small
              v-if="g.pallet_id === 'new' && g.warehouse_id && palletsFor(g).length == 0"
              class="send-hint"
            >No open pallet from {{ g.country }} yet: write the number of the new plane, or choose "No pallet" above.</small>
            <small
              v-if="g.pallet_id === 'none'"
              class="send-hint"
            >These orders will not be in any pallet report. They can be added to a pallet later from the Pallets page.</small>
            <small
              v-if="g.pallet_id === 'skip'"
              class="send-hint"
            >These orders stay in Pending To Shipment.</small>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="height:auto"
            outline
            :disabled="sendBusy"
            @click="sendWindow = false"
          >Cancel</v-btn>
          <v-btn
            style="height:auto"
            outline
            color="success"
            :disabled="sendBusy"
            @click="confirmSend()"
          ><i class="fa fa-send"></i> Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import sendToIntShipment from '../sendToIntShipment.vue'
import viewOrderDetails from '../viewOrderDetails.vue'
import mobileDatatable from '../mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'send-to-int-shipment': sendToIntShipment,
    'view-order-details': viewOrderDetails,
    'mobile-datatable': mobileDatatable,
  },
  created() {
    this.getLoggedInUser()
    this.getPallets()
  },
  mounted() {
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: 'Check Box', value: '1' },
      {
        label: 'User',
        text: 'User',
        value: '2',
        sortable: false,
        searchable: false,
        name: 'user'
      },
      {
        label: 'Qr ID',
        text: 'Qr ID',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'order_id',
      },
      {
        label: 'OrderID',
        text: 'OrderID',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'theOrderID',
      },
      {
        label: 'Customer ID',
        text: 'Customer ID',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'customer_id_fk',
      },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'full_name',
      },
      {
        label: 'Customer Note',
        text: 'Customer Note',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'customer_note',
      },
      {
        label: 'Product URL',
        text: 'Product URL',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'product_url',
      },
      {
        label: 'Product Name',
        text: 'Product Name',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'product_name',
      },
      {
        label: 'Qty',
        text: 'Qty',
        value: '10',
        sortable: true,
        searchable: true,
        name: 'quantity',
      },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '11',
        sortable: true,
        searchable: true,
        name: 'country',
      },
      {
        label: 'Type',
        text: 'Type',
        value: '12',
        sortable: true,
        searchable: true,
        name: 'transportation_type_obj',
      },
      {
        label: 'Purchase Note',
        text: 'Purchase Note',
        value: '13',
        sortable: true,
        searchable: true,
        name: 'purchase_note',
      },
      {
        label: 'Order Note',
        text: 'Order Note',
        value: '14',
        sortable: true,
        searchable: true,
        name: 'note',
      },
      {
        label: 'Date',
        text: 'Date',
        value: '15',
        sortable: true,
        searchable: true,
        name: 'int_shipment_date',
      },
      {
        label: 'Bank',
        text: 'Bank',
        value: '16',
        sortable: true,
        searchable: true,
        name: 'bank_name',
      },
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/pending_to_shipment_order',
      intShipmentUrl: 'api/int_shipmenting',
      initMultipleShipmentUrl: 'api/int_shipmenting_multiple_order',
      intShipmentByQrCodeUrl: 'api/int_shipmenting_by_qrcode',
      // the send window: which plane each group of orders goes on
      sendWindow: false,
      sendGroups: [],
      sendMode: 'multiple',
      sendBusy: false,
      openPallets: [],
      warehouses: [],
      originOf: {},
      orderDetailUrl: 'api/show_order_detail',
      sendToIntShipmentModal: false,
      sendToIntShipmentData: {
        order_id: ''
      },
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      generateQrCodeModal: false,
      checkAlert: false,
      btnsave: true,
      queryParameter: true,
      qrCodeValues: [],
      loggedInUserData: {},
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      orderID: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        warehouse: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: '',
      },
    }
  },
  methods: {
    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    // the window needs the origin (USA, China, UAE) of each selected order; rows carry it
    rememberOrigins() {
      this.apiResults.forEach(r => {
        this.$set(this.originOf, r.order_id, { warehouse_id: r.warehouse_id_fk, country: r.country })
      })
    },

    getPallets() {
      const headers = { Authorization: 'Bearer ' + localStorage.getItem('access_token') }
      axios
        .get('api/pallets/list', { params: { open: 1 }, headers })
        .then(response => { this.openPallets = response.data })
        .catch(() => { })
      axios
        .get('api/warehouses', { headers })
        .then(response => { this.warehouses = response.data.data || [] })
        .catch(() => { })
    },

    palletsFor(group) {
      return this.openPallets.filter(p => !group.warehouse_id || p.warehouse_id_fk == group.warehouse_id)
    },

    // One group per origin; the newest open pallet of that origin is chosen, otherwise a new one.
    openSendWindow(orderIds, mode) {
      const groups = {}
      orderIds.forEach(id => {
        const origin = this.originOf[id] || { warehouse_id: null, country: null }
        const key = origin.warehouse_id || 'unknown'
        if (!groups[key]) {
          groups[key] = { key, warehouse_id: origin.warehouse_id, country: origin.country, order_ids: [], pallet_id: 'new', new_number: '', new_date: '', new_warehouse_id: null }
        }
        groups[key].order_ids.push(id)
      })
      this.sendGroups = Object.values(groups)
      this.sendGroups.forEach(g => {
        const open = this.palletsFor(g)
        g.pallet_id = open.length > 0 ? open[0].pallet_id : 'new'
      })
      this.sendMode = mode
      this.sendWindow = true
      this.getPallets()
    },

    confirmSend() {
      for (const g of this.sendGroups) {
        if (g.pallet_id === 'new' && !g.new_number.trim()) {
          return swal('Error', 'Write the plane number for ' + (g.country || 'the new pallet'), 'error')
        }
        if (g.pallet_id === 'new' && !g.warehouse_id && !g.new_warehouse_id) {
          return swal('Error', 'Choose the origin of the plane', 'error')
        }
      }
      const toSend = this.sendGroups.filter(g => g.pallet_id !== 'skip')
      if (toSend.length === 0) {
        return swal('Error', 'Nothing is chosen to send', 'error')
      }
      const headers = { Authorization: 'Bearer ' + localStorage.getItem('access_token') }
      this.sendBusy = true
      let chain = Promise.resolve()
      toSend.forEach(g => {
        chain = chain
          .then(() => {
            if (g.pallet_id === 'none') {
              // sent the old way: the order gets no pallet
              return null
            }
            if (g.pallet_id !== 'new') {
              return g.pallet_id
            }
            return axios
              .post('api/pallets', { tracking_number: g.new_number.trim(), warehouse_id_fk: g.warehouse_id || g.new_warehouse_id, flight_date: g.new_date || null }, { headers })
              .then(response => response.data.pallet_id)
          })
          .then(palletId => {
            if (this.sendMode === 'multiple') {
              return axios.put(this.initMultipleShipmentUrl, { orders_id: g.order_ids, pallet_id: palletId }, { headers })
            }
            const url = this.sendMode === 'qr' ? this.intShipmentByQrCodeUrl : this.intShipmentUrl
            return axios.put(url + '/' + g.order_ids[0], { pallet_id: palletId }, { headers })
          })
      })
      chain
        .then(() => {
          this.sendWindow = false
          this.sendToIntShipmentData.order_id = ''
          this.qrCodeValues = []
          this.getResults()
          swal({ title: 'Done', text: '', icon: 'success', timer: 1500, buttons: false })
        })
        .catch(error => {
          this.getResults()
          let message = (error.response && error.response.data.message) || 'Something went wrong'
          if (typeof message !== 'string') {
            message = Object.values(message).map(m => [].concat(m).join(' ')).join(' ')
          }
          swal('Error', message, 'error')
        })
        .then(() => { this.sendBusy = false })
    },

    sendAllToIntShipment() {
      const ordersId = this.qrCodeValues.map(e => e[0])

      if (ordersId.length === 0) {
        return swal('Error', 'Please select order', 'error')
      }

      this.openSendWindow(ordersId, 'multiple')
    },

    openSendToIntShipmentModal() {
      this.sendToIntShipmentModal = true
    },

    closeSendToIntShipmentModal() {
      this.sendToIntShipmentModal = false
      this.sendToIntShipmentData.order_id = ''
      this.$validator.reset()
    },

    // the QR window: the typed order is sent through the send window like the others
    sendToIntShipment() {
      this.openSendWindow([this.sendToIntShipmentData.order_id], 'qr')
    },

    shipmentOrder(id) {
      this.openSendWindow([id], 'single')
    },

    sendToExport() {
      let arr = ''

      for (let i = 0; i < this.orderID.length; i++) {
        if (i < this.orderID.length - 1) {
          arr = arr.concat('arr[]=' + this.orderID[i] + '&')
        } else {
          arr = arr.concat('arr[]=' + this.orderID[i])
        }
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      window.location.replace(fullHostName + '/api/pending-shipping-export?' + arr)
    },

    getOrderID(orders) {
      this.orderID = []
      for (let i = 0; i < orders.length; i++) {
        this.orderID[i] = orders[i].order_id
      }
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
            this.rememberOrigins()
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
            this.rememberOrigins()
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          this.getOrderID(this.apiResults)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(() => { })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.warehouse = ''
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    getByWarehouse(warehouse) {
      this.tableData.warehouse = warehouse
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true,
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },

    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },
  },
}
</script>

<style>
.send-group {
  margin-bottom: 14px;
  padding: 12px 14px;
  background: #f7f8fc;
  border: 1px solid #e6e8f0;
  border-radius: 6px;
}

.send-group-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.send-group select.form-control,
.send-group input.form-control {
  height: 36px;
  padding: 6px 10px;
  background: #fff;
  border: 1px solid #d5d9e3;
  border-radius: 4px;
  -webkit-appearance: menulist;
  appearance: auto;
}

.send-new {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.send-new .form-control {
  flex: 1 1 0;
  width: auto;
  min-width: 0;
}

.send-new input[type='text'] {
  flex: 2 1 0;
}

.send-hint {
  display: block;
  margin-top: 6px;
  color: #c96a12;
}


.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

.danger-swal {
  background: #ff6262 !important;
}
a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pendingToShipment/pendingToShipment.vue